import React from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { Button } from '@insurancemenu/imenu-components-lib';
import { ArrowBack } from '@insurancemenu/imenu-components-lib/dist/icons';
import { createStyles } from './styles';

interface CommonHeaderProps {
  title: string;
  subtitle?: string;
  headerClassName?: string;
  showBackButton?: boolean;
  onRedirect?: () => void;
}

const CommonHeader = ({
  title,
  subtitle,
  headerClassName,
  showBackButton = true,
  onRedirect,
}: CommonHeaderProps): JSX.Element => {
  const history = useHistory();
  const classes = createStyles();

  const backButtonStyle = !subtitle && classes.backButtonInLine;

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  return (
    <header className={clsx(classes.header, headerClassName)}>
      {showBackButton && (
        <Button
          leftIconProp={<ArrowBack />}
          type="text"
          size="medium"
          onClick={onRedirect || onBackButtonClick}
          className={clsx(classes.backButton, backButtonStyle)}
        >
          Back
        </Button>
      )}
      <h1 className={classes.title}>{title}</h1>
      {subtitle && <p className={classes.caption}>{subtitle}</p>}
    </header>
  );
};

export default CommonHeader;
